import { render } from "./CoBrandGrove.vue?vue&type=template&id=d4f0d81a&scoped=true"
import script from "./CoBrandGrove.vue?vue&type=script&lang=js"
export * from "./CoBrandGrove.vue?vue&type=script&lang=js"

import "./CoBrandGrove.vue?vue&type=style&index=0&id=d4f0d81a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4f0d81a"]])

export default __exports__